var map = {
	"./labmemtest_text_btn02_en.png": "3289",
	"./labmemtest_text_btn02_jp.png": "f474",
	"./labmemtest_text_btn02_kr.png": "0034",
	"./labmemtest_text_btn02_sc.png": "f230",
	"./labmemtest_text_btn02_tc.png": "4317"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2ea";